<template>
	<div style="padding-right: 20px; padding-left: 10px;">	
	<v-layout class="listlayout" column >
		<v-flex shrink>
			<v-layout row align-center>
				<v-flex>
					<v-select 
					v-model="selectedRoomAttribute"
					:items="chooserItems"
					item-text="text"
					item-value="val"
					label="Choose Categorization"
					single-line>
					</v-select>
				</v-flex>
				<v-flex shrink class="ml-4">
					<v-menu offset-y>
				      <template v-slot:activator="{ on }">
				        <v-btn icon v-on="on">
				          <v-icon color="grey darken-3">settings</v-icon>
				        </v-btn>
				      </template>
				      <v-list>
				        <v-list-tile @click="clearColors" >
				          <v-list-tile-title>Set All White</v-list-tile-title>
				        </v-list-tile>
				        <v-list-tile @click="useGradient" >
				          <v-list-tile-title>Use Default Gradient</v-list-tile-title>
				        </v-list-tile>
				        <v-list-tile @click="toggleDepartmentColors(true)" v-if="colorAttribute=='deptName'">
				          <v-list-tile-title>Use Dept Colors</v-list-tile-title>
				        </v-list-tile>
				      </v-list>
				    </v-menu>
    			</v-flex>
			</v-layout>
		</v-flex>
			<div class="categorylist">
		      	<v-list
		      		v-if="colorAttribute" 
		      		v-for="(item, index) in legend" 
		      		:key="item.label">
		        	<v-list-tile  
		        		@click="legendClickHandler(item, index)" 
		        		class="legendlisttile"
		        		:class="{ selectedCategory : selectedIndex == index }"
		        		 >
	    					<v-layout
		    					row	    					 					
		    					class="title font-weight-light" 		    					
		    					>
		    						
			    						<v-tooltip left>
				                            <v-btn slot="activator" class="colorbox" v-bind:style="{ backgroundColor: item.color}"
				                                @click.stop="changeColor(item)">
				                            </v-btn>
				                            <span>Change Color</span>
				                        </v-tooltip>
				                        <ColorPicker v-on:change-color="updateColor" v-if="showColorPicker && currentColorPicker == item" class="categorizerColorPicker"/>
				                    
						          	<v-flex ml-2 pt-1 xs9 pr-2 v-html="item.label" />
						          	<v-flex xs2 class="text-xs-right" v-html="item.area && item.area.toLocaleString()"/>
			          		</v-layout>
			   	 	</v-list-tile>			   	 	

		        </v-list>
		        </div>
		    </v-layout>
		        <v-divider v-if="colorAttribute" class="mt-3"></v-divider>
		        <v-list-tile v-if="colorAttribute" class="legendlisttile">
		        	<v-layout class="mt-2 mb-4 title font-weight-light">
				    	<v-flex xs3 class="" >				    		
				    	</v-flex>
				    	<v-flex xs9>				    		
				    	</v-flex>
				    	<v-flex xs9 class="text-xs-right">
				    		{{areaTotal}}
				    	</v-flex>
				    </v-layout>
				</v-list-tile>

<!-- 		        <v-list-tile v-if="colorAttribute" class="legendlisttile">
			    	<v-flex xs2 class="" >
			    	<v-tooltip right>
		                <v-btn slot="activator" class="colorbox" v-bind:style="{ backgroundColor: 'white'}"
		                    @click.stop="clearColors">
		                    <v-icon small >block</v-icon>
		                </v-btn>
		                <span>Whiteout Floorplan</span>
		            </v-tooltip>
			    	</v-flex>
			   	</v-list-tile>
			   	<v-list-tile v-if="colorAttribute" class="legendlisttile">
			    	<v-flex xs2 class="" >
			    	<v-tooltip right>
		                <v-btn slot="activator" class="colorbox" v-bind:style="{ backgroundColor: 'white'}"
		                    @click.stop="useGradient">
		                    <v-icon small >gradient</v-icon>
		                </v-btn>
		                <span>Use Default Gradient</span>
		            </v-tooltip>
			    	</v-flex>
			   	</v-list-tile>
			   	<v-list-tile v-if="colorAttribute=='deptName'" class="legendlisttile">
			    	<v-flex xs2 class="" >
			    	<v-tooltip right>
		                <v-btn slot="activator" class="colorbox" v-bind:style="{ backgroundColor: 'white'}"
		                    @click.stop="toggleDepartmentColors(true)">
		                    <v-icon small >dns</v-icon>
		                </v-btn>
		                <span>Use Dept Colors</span>
		            </v-tooltip>
			    	</v-flex>
			   	</v-list-tile> -->
	    	

	    	

	</div>

</template>

<script>

import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import ColorPicker from './ColorPicker'
import hexRgb from'hex-rgb'


//import d3Interpolate from 'd3-interpolate'
// Couldn't figure this out, so it was cdn included in index.html

let TabColorize = {
	name: TabColorize,
	data() {
		return {
			dialog: 			{},
			color: 				'#1CA085',
			showColorPicker:    false,
			prevLabel: null,
			selectedIndex: null,
			chooserItems: [		{ text : 'Categorized by Department',		val : 'deptName', 			},			
								{ text : 'Categorized by College',			val : 'collegeName', 		},		
								{ text : 'Categorized by Category',			val : 'categoryName', 		},				
								{ text : 'Categorized by Type',				val : 'typeName', 			},		
								{ text : 'Categorized by Use',				val : 'useName', 			},
								{ text : 'Categorized by Utilization',		val : 'utilization', 			},
								{ text : 'Categorized by Suitability',		val : 'suitability', 			},
								{ text : 'Categorized by Condition',		val : 'condition', 			},
								{ text : 'Categorized by Dept + Classification',	val : 'deptclass', 	},
								{ text : 'Categorized by Dept Share Exploded',	val : 'deptExploded', 	},
								{ text : 'Categorized by Dept Share Blend',	val : 'deptShareBlend', 	},
								{ text : 'Categorized by Classification',	val : 'classification', 	},
								{ text : 'Categorized by Dept / Loaned',	val : 'loaned', 			},
								{ text : 'Categorized by Position Desc',	val : 'position', 			},
								
								

			]
		}
	},

	components: { ColorPicker },

	computed: {
		...mapGetters(['colorizeArray', 'uniqueCategories']),
		...mapState({
				colorAttribute: state => state.colorRooms.colorAttribute,
				currentFloor: state => state.ui.currentFloor,
				buildingRooms: state => state.space.buildingRooms,
				highlightRoomsByKey: state => state.mapFunctions.highlightRoomsByKey,
				clearGraphics: state => state.mapFunctions.clearGraphics,
				legend: state => state.colorRooms.legend,
				useDeptColors: state => state.colorRooms.useDeptColors
	  	}),

	  	selectedRoomAttribute : {
			get () {
				return this.colorAttribute
			},
			set (value) {						// Setting this will trigger colorization
				this.setHatchClassOn(false)
				this.setColorDomain("room")
				this.setColorAttribute(value)
				if (value == 'deptclass') {
					this.setColorAttribute('deptName')
					this.setHatchClassOn(true)
					this.setLegendOpen(true)
				}
				this.buildColorizedLegendArray()
			}
		},

        areaTotal () { 
        	let sum = null
        	this.legend.map((row) => sum += row.area) 
        	return sum ? sum.toLocaleString() : null
        },

        clearGraphics (value) { return this.$store.state.mapFunctions.clearGraphics}

	},

	methods: {
		...mapMutations([	'setcolorizeProperty', 
							'setColorizeFeatureAttribute',
							'updateSelectionCentering',
							'setColorizeArray',
							'updateColors',
							'setColorUseDefault',
							'setColorDomain',
							'setColorAttribute',
							'setUseDeptColors',
							'setHatchClassOn',
							'setLegendOpen',
							]),

		...mapActions(['buildColorizedLegendArray']),

		changeColor: function (item) {
			this.currentColorPicker = item
            this.showColorPicker = true
        },

        updateColor: function (value) {
        	if (value) {
            	this.currentColorPicker.color = `rgb(${hexRgb(value).red}, ${hexRgb(value).green}, ${hexRgb(value).blue})`
            	if (value == "#FFFFFF") { this.currentColorPicker.color = 'rgb(255,255,255)' }
            }

            this.showColorPicker = false
            this.updateColors({ legendLabel: this.currentColorPicker.label, color: value })
            this.buildColorizedLegendArray()

        	event.stopPropagation()
        },

        clearColors: function () {
        	this.legend.forEach((row) => {
        		this.updateColors({ legendLabel: row.label, color: '#FFFFFF', skipExisting: true })
        	})
        	this.buildColorizedLegendArray()
        },

        toggleDepartmentColors: function (payload) {
        	this.setUseDeptColors(payload)
        	this.buildColorizedLegendArray()
        },

        useGradient: function () {
        	this.updateColors("Clear")
        	this.setUseDeptColors(false)
        	this.buildColorizedLegendArray()
        },

        selectChangeHandler: function (val) {
			this.setColorDomain("room")
			this.setColorAttribute(val)
			this.buildColorizedLegendArray()
		},

		// Legend Click will highlight related rooms
		legendClickHandler: function (item, index) {
			this.selectedIndex = index
			//console.log(index)

			// If clicked same label, interpret that as a 'clear' command.
			if (this.prevLabel == item) {
				this.clearGraphics('multihighlightlayer')
				this.prevLabel = null
				return
			}

			this.prevLabel = item
			let floor = this.currentFloor
			/*let matchingRooms = this.buildingRooms.filter((room) => room.floor === floor &&
				room[this.colorAttribute] === label)*/

			const roomKeyArray = item.rooms.map((room) => {return room.roomKey})

			this.clearGraphics('multihighlightlayer')
			this.highlightRoomsByKey(roomKeyArray)
		},

	}
}


export default TabColorize

</script>


<style>

ul {
  list-style-type: none;
}

/* MAIN CSS MODIFIES THIS FOR SMALL SCREENS.  SEE MAIN.CSS */
.listlayout {
    max-height: calc(100vh - 400px);    
    overflow: hidden; 
}

.selectedCategory {
	background-color: gainsboro;
}

.categorizerColorPicker {
    position: absolute !important;
    top: 0px;
    left: 15px;
    width: 200px;
    z-index: 1;
}

.categorylist {
	overflow-y: auto !important;
}

.colorbox {
	width: 9px;
	height: 16px !important;
	margin-top: 2px;
	margin-left: 0px !important;
	border-style: solid;
	border-width: 1px;
	opacity: .75;
	min-width: 20px !important;
}

.colorbox > .v-btn {
	margin: 0;
	padding: 0;
}

.categorylist > .v-list {
	padding: 0px;
	margin-bottom: 3px;
}

.legendlisttile > .v-list__tile {
    height: auto;
    padding: 0;
    padding-right: 10px;
    padding-top: 1px;

}

.legendlisttile > .v-list__tile > .v-title {
	padding-bottom: -5px;
	line-height: normal !important;
}


</style>







// WEBPACK FOOTER //
// src/components/buildingcard/TabColorize.vue